import React, { Component } from 'react'
import styled from 'styled-components'

import { MEDIA_BASE_URL } from 'config'

import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import BigModalV2 from '../BigModalV2'

import IcNetwork from '../DetailsModalV2/images/ic-network.component.svg'
import IcElectricGas from '../DetailsModalV2/images/ic-eletricity-gas.component.svg'
import IcServices from '../DetailsModalV2/images/ic-support.component.svg'
import IcDiscounts from '../DetailsModalV2/images/ic-discounts.component.svg'
import IcTaxes from '../DetailsModalV2/images/ic-taxes.component.svg'
import IcResult from '../DetailsModalV2/images/ic-result.component.svg'
import IcHouse from './images/ic-house.component.svg'
import IcInfo from './images/ic-info2.component.svg'
import IcWinner from './images/ic-winner.component.svg'
import TooltipV2 from '../TooltipV2'

import { pricesCurrency, currency } from 'utils'

const TABLE_KEYS = [
  'medal',
  'logo',
  'designation',
  'electricity',
  'gas',
  'additional_services',
  'potency',
  'tariff',
  'cycle',
  'stage',
  'billing',
  'network_access',
  'energy',
  'other_services',
  'refunds_discounts',
  'taxes',
  'annual_billing',
]

export default class CompareModalV2 extends Component {
  generateCellKey = (key, id) => {
    return `compare_cell_row_${key}_item_${id}`
  }

  renderElectricityCell = (key, item, cheapId) => {
    const timeCycle = item.priceListTimeCycle
    const elePrices = item.prices.electricity

    return (
      <ListCell
        key={this.generateCellKey(key, item.id)}
        cheap={item.id === cheapId}>
        <PriceDetails>
          <Detail lighter>Termo Potência</Detail>
          <Detail lighter>
            <b>{pricesCurrency(elePrices.termo_fixo) || '---'}</b> €/dia
          </Detail>
        </PriceDetails>
        {timeCycle === 's' ? (
          <PriceDetails>
            <Detail lighter>Energia</Detail>
            <Detail lighter>
              <b>{pricesCurrency(elePrices.cheia) || '---'}</b> €/kWh
            </Detail>
          </PriceDetails>
        ) : null}
        {timeCycle !== 's' ? (
          <PriceDetails>
            <Detail lighter>Vazio</Detail>
            <Detail lighter>
              <b>{pricesCurrency(elePrices.vazio) || '---'}</b> €/kWh
            </Detail>
          </PriceDetails>
        ) : null}
        {timeCycle === 'b' ? (
          <PriceDetails>
            <Detail lighter>Fora do Vazio</Detail>
            <Detail lighter>
              <b>{pricesCurrency(elePrices.cheia) || '---'}</b> €/kWh
            </Detail>
          </PriceDetails>
        ) : null}
        {timeCycle !== 's' && timeCycle !== 'b' ? (
          <PriceDetails>
            <Detail lighter>Ponta</Detail>
            <Detail lighter>
              <b>{pricesCurrency(elePrices.ponta) || '---'}</b> €/kWh
            </Detail>
          </PriceDetails>
        ) : null}
        {timeCycle !== 's' && timeCycle !== 'b' ? (
          <PriceDetails>
            <Detail lighter>Cheias</Detail>
            <Detail lighter>
              <b>{pricesCurrency(elePrices.cheia) || '---'}</b> €/kWh
            </Detail>
          </PriceDetails>
        ) : null}
      </ListCell>
    )
  }

  renderRow = (key, updatedList) => {
    const mostCheap = updatedList.reduce((prev, curr) =>
      Number(prev.annualBilling) < Number(curr.annualBilling) ? prev : curr
    )
    const hasElectricity = Boolean(updatedList[0].electricityPriceList)
    const hasGas = Boolean(updatedList[0].gasPriceList)
    let empty = false
    let cells = []

    if (key === 'medal') {
      empty = true
      cells.push(<Cell></Cell>)
      updatedList.forEach((item) =>
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}
            center>
            {item.id === mostCheap.id && <IcWinner />}
            {item.id === mostCheap.id && <MedalText>Mais Económico</MedalText>}
          </Cell>
        )
      )
    } else if (key === 'logo') {
      cells.push(<Cell></Cell>)
      updatedList.forEach((item, index) => {
        const energyPriceList = hasElectricity
          ? item.electricityPriceList
          : item.gasPriceList
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}
            center>
            {index === 0 && <IcHouse />}
            {index > 0 && (
              <img
                src={`${MEDIA_BASE_URL}${energyPriceList.entity.hi_res_logo}`}
                alt={energyPriceList.designation}
              />
            )}
          </Cell>
        )
      })
    } else if (key === 'designation') {
      cells.push(
        <Cell>
          <Detail defaultText>Tarifário</Detail>
        </Cell>
      )
      updatedList.forEach((item, index) => {
        const energyPriceList = hasElectricity
          ? item.electricityPriceList
          : item.gasPriceList
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              {index === 0 ? 'O meu tarifário' : energyPriceList.designation}
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'electricity') {
      if (hasElectricity) {
        cells.push(
          <Cell>
            <Detail defaultText>Eletricidade</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          cells.push(this.renderElectricityCell(key, item, mostCheap.id))
        })
      } else {
        empty = true
      }
    } else if (key === 'gas') {
      if (hasGas) {
        cells.push(
          <Cell>
            <Detail defaultText>Gás Natural</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          cells.push(
            <ListCell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <PriceDetails>
                <Detail lighter>Termo Fixo</Detail>
                <Detail lighter>
                  <b>{pricesCurrency(item.prices.gas.termo_fixo) || '---'}</b>{' '}
                  €/dia
                </Detail>
              </PriceDetails>
              <PriceDetails>
                <Detail lighter>Energia</Detail>
                <Detail lighter>
                  <b>
                    {pricesCurrency(item.prices.gas.termo_energia) || '---'}
                  </b>{' '}
                  €/kWh
                </Detail>
              </PriceDetails>
            </ListCell>
          )
        })
      } else {
        empty = true
      }
    } else if (key === 'additional_services') {
      cells.push(
        <Cell>
          <Detail defaultText>Condições Adicionais</Detail>
        </Cell>
      )
      updatedList.forEach((item) => {
        const additionalServices = hasElectricity
          ? item.electricityPriceList.additional_services
          : item.gasPriceList.additional_services
        if (!additionalServices.length) {
          cells.push(
            <Cell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <Detail>-</Detail>
            </Cell>
          )
        } else {
          cells.push(
            <ServicesCell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              {additionalServices.map((service) => (
                <Detail>{service.name}</Detail>
              ))}
            </ServicesCell>
          )
        }
      })
    } else if (key === 'potency') {
      if (hasElectricity) {
        cells.push(
          <Cell>
            <Detail defaultText>Potência</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          cells.push(
            <Cell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <Detail>
                <b>{currency(item.calculatedHiredPowerFactor)}</b> kVA
              </Detail>
            </Cell>
          )
        })
      } else {
        empty = true
      }
    } else if (key === 'tariff') {
      if (hasElectricity) {
        cells.push(
          <Cell>
            <Detail defaultText>Tarifa</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          const timeCycle = item.priceListTimeCycle
          const text =
            timeCycle === 's'
              ? 'Simples'
              : timeCycle === 'b'
              ? 'Bi-Horário'
              : timeCycle === 't'
              ? 'Tri-Horário'
              : '-'
          cells.push(
            <Cell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <Detail bold>{text}</Detail>
            </Cell>
          )
        })
      } else {
        empty = true
      }
    } else if (key === 'cycle') {
      if (hasElectricity) {
        cells.push(
          <Cell>
            <Detail defaultText>Ciclo Horário</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          cells.push(
            <Cell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <Detail bold>Diário</Detail>
            </Cell>
          )
        })
      } else {
        empty = true
      }
    } else if (key === 'stage') {
      if (hasGas) {
        cells.push(
          <Cell>
            <Detail defaultText>Escalão</Detail>
          </Cell>
        )
        updatedList.forEach((item) => {
          cells.push(
            <Cell
              key={this.generateCellKey(key, item.id)}
              cheap={item.id === mostCheap.id}>
              <Detail bold>{item.prices.gas.stage}</Detail>
            </Cell>
          )
        })
      } else {
        empty = true
      }
    } else if (key === 'billing') {
      cells.push(
        <Cell title>
          <Detail title>Faturação</Detail>
        </Cell>
      )
      updatedList.forEach((item) => {
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}></Cell>
        )
      })
    } else if (key === 'network_access') {
      cells.push(
        <IconCell>
          <IcNetwork />
          <Detail lighter tooltip>
            Potência
            <TooltipV2
              style={{ height: '16px' }}
              contentStyle={{ maxWidth: '180px' }}
              content={
                <TooltipText>Inclui Tarifa de Acesso às Redes.</TooltipText>
              }
              arrowLocation='topLeft'>
              <IcInfo width='16px' height='16px' />
            </TooltipV2>
          </Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        const eleAnnualFixedTerm = hasElectricity
          ? Number(item.electricityFixedTerm)
          : 0
        const gasAnnualFixedTerm = hasGas ? Number(item.gasFixedTerm) : 0
        const monthlyNetworkAccess = eleAnnualFixedTerm + gasAnnualFixedTerm
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              <b>{monthlyNetworkAccess.toFixed(2).replace('.', ',')}</b> €
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'energy') {
      cells.push(
        <IconCell>
          <IcElectricGas />
          <Detail lighter tooltip>
            Energia
            <TooltipV2
              style={{ height: '16px' }}
              contentStyle={{ maxWidth: '180px' }}
              content={
                <TooltipText>Inclui Tarifa de Acesso às Redes.</TooltipText>
              }
              arrowLocation='topLeft'>
              <IcInfo width='16px' height='16px' />
            </TooltipV2>
          </Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        const eleAnnualEnergy = hasElectricity
          ? Number(item.electricityEnergy)
          : 0
        const gasAnnualEnergy = hasGas ? Number(item.gasEnergy) : 0
        const monthlyEnergy = eleAnnualEnergy + gasAnnualEnergy
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              <b>{monthlyEnergy.toFixed(2).replace('.', ',')}</b> €
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'other_services') {
      cells.push(
        <IconCell>
          <IcServices />
          <Detail lighter>Outros Serviços</Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            {/* TODO - Descomentar isto quando o field for enviado da api */}
            {/* <Detail><b>{currency(item.aditionalServicesCost)}</b> €</Detail> */}
            <Detail>
              <b>0</b> €
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'refunds_discounts') {
      cells.push(
        <IconCell>
          <IcDiscounts />
          <Detail lighter>Reembolsos/Descontos</Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              <b>{currency(item.annualRefunds)}</b> €
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'taxes') {
      cells.push(
        <IconCell>
          <IcTaxes />
          <Detail lighter>Taxas e Impostos</Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              <b>{currency(item.annualTaxes)}</b> €
            </Detail>
          </Cell>
        )
      })
    } else if (key === 'annual_billing') {
      cells.push(
        <IconCell>
          <IcResult />
          <Detail lighter>Valor Anual</Detail>
        </IconCell>
      )
      updatedList.forEach((item) => {
        cells.push(
          <Cell
            key={this.generateCellKey(key, item.id)}
            cheap={item.id === mostCheap.id}>
            <Detail>
              <b>{currency(item.annualBilling)}</b> €
            </Detail>
          </Cell>
        )
      })
    }

    return (
      <Row key={`compare_row_${key}`} empty={empty}>
        {cells}
      </Row>
    )
  }

  renderBtnsRow = (updatedList) => {
    const mostCheap = updatedList.reduce((prev, curr) =>
      Number(prev.annualBilling) < Number(curr.annualBilling) ? prev : curr
    )
    let cells = []

    updatedList.forEach((item, index) => {
      if (index === 0) {
        cells.push(<BtnCell></BtnCell>)
      } else {
        const moreInfoParams = {
          ...this.props,
          priceListId: item.id,
        }

        if (item.electricityPriceList) {
          moreInfoParams.id = item.electricityPriceList.id
        } else if (item.gasPriceList) {
          moreInfoParams.id = item.gasPriceList.id
        }
        const BtnComponent =
          item.id === mostCheap.id ? ButtonGradientV2 : ButtonOutlineV2
        cells.push(
          <BtnCell>
            <BtnComponent onClick={() => this.props.onJoin(moreInfoParams)}>
              Aderir ao Tarifário
            </BtnComponent>
          </BtnCell>
        )
      }
    })

    return (
      <BtnsRow>
        <BtnCell></BtnCell>
        {cells}
      </BtnsRow>
    )
  }

  renderTable = () => {
    const { compareList, simulation } = this.props
    const updatedList = [simulation.results, ...compareList]

    return (
      <Table>
        <tbody>
          {TABLE_KEYS.map((key) => this.renderRow(key, updatedList))}
        </tbody>
        {this.renderBtnsRow(updatedList)}
      </Table>
    )
  }

  render() {
    const { onClose } = this.props

    return (
      <BigModalV2
        modalTriggerHeight={this.props.modalTriggerHeight}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        title='Comparar Resultados'
        onClose={onClose}
        style={{ width: '950px' }}>
        {this.renderTable()}
      </BigModalV2>
    )
  }
}

const TooltipText = styled.p`
  color: #fff;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  min-width: 250px;
  margin: 0;
`

const Table = styled.table`
  display: flex;
  flex-direction: column;
  border: 1px solid #ececec;
  flex: 1 0 0;
  width: 100%;
  border-spacing: 0;
  align-self: stretch;

  > tbody {
    overflow-y: auto;
    width: 100%;
    flex: 1 0 0;
    align-self: stretch;
  }
`

const Row = styled.tr`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-bottom: ${({ empty }) => !empty && `1px solid #ECECEC`};
`

const BtnsRow = styled.tr`
  display: flex;
  align-items: center;
  gap: 4px;
`

const ListCell = styled.td`
  display: flex;
  padding: 10px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  align-self: stretch;

  ${({ cheap }) =>
    cheap &&
    `
    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;
  `}
`

const Detail = styled.p`
  color: #1D1E22;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  margin: 0;

  > b {
    color: #1D1E22;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  }

  ${({ defaultText }) =>
    defaultText &&
    `
    color: #676767;
    font-weight: 600;
  `}

  ${({ title }) =>
    title &&
    `
    color: #006736;
    font-weight: 700;
  `}

  ${({ lighter }) =>
    lighter &&
    `
    color: #3E3E3E;
  `}

   ${({ bold }) =>
     bold &&
     `
    font-weight: 700;
  `}

  ${({ tooltip }) =>
    tooltip &&
    `
    display: flex;
    align-items: center;
    gap: 4px;
  `}
`

const ServicesCell = styled.td`
  display: flex;
  align-items: center;
  align-content: center;
  padding: 10px 16px;
  align-self: stretch;
  flex-wrap: wrap;
  flex: 1 0 0;
  gap: 4px;

  ${({ cheap }) =>
    cheap &&
    `
    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;
  `}
`

const PriceDetails = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 4px;
`

const Cell = styled.td`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;

  > img {
    width: 60px;
    height: 30px;
    object-fit: contain;
  }


  ${({ title }) =>
    title &&
    `
    padding: 10px 16px;
  `}

  ${({ cheap }) =>
    cheap &&
    `
    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;
  `}

  ${({ center }) =>
    center &&
    `
    justify-content: center;
  `}
`

const MedalText = styled.h4`
  color: #006736;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  margin: 0;
  text-transform: uppercase;
`

const IconCell = styled.td`
  display: flex;
  padding: 8px 16px;
  flex: 1 0 0;
  display: flex;
  align-items: center;
  gap: 4px;
`

const BtnCell = styled.td`
  display: flex;
  height: 72px;
  padding: 16px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`



// WEBPACK FOOTER //
// ./src/components/CompareModalV2/index.js